import type { SwanTransaction } from "./models.js";

export const getSwanTransactionAmount = (transaction: SwanTransaction) => {
  return transaction.side === "Credit"
    ? parseFloat(transaction.amount.value)
    : -parseFloat(transaction.amount.value);
};
